import { graphqlClient } from '@/lib/graphql-client';
import { buildGetContactCantonsQuery } from '../graphql/contact-info-lookups';

/** One canton / division / district / state; `State` is the value stored on the employee, `ItemId` is the legacy LocationId. */
export interface CantonOption {
  ItemId: string;
  State: string;
}

interface LocationRow {
  ItemId: string;
  State?: string | null;
}

/** Legacy canton lists were fetched with page size 100; cantons stay far below this. */
const LOOKUP_PAGE_SIZE = 300;

/** Cantons of the active organization, which stands for the country of employment. */
export const getContactCantons = async (): Promise<CantonOption[]> => {
  const result = await graphqlClient.query<{ Locations: { items: LocationRow[] } }>({
    query: buildGetContactCantonsQuery({}, 1, LOOKUP_PAGE_SIZE),
  });
  return result.Locations.items
    .filter((location): location is LocationRow & { State: string } => Boolean(location.State))
    .map((location) => ({ ItemId: location.ItemId, State: location.State }))
    .sort((a, b) => a.State.localeCompare(b.State));
};
